/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import * as THREE from 'three';
import React, { useRef } from 'react'
import { useGLTF, useTexture } from '@react-three/drei'
import { useLoader } from '@react-three/fiber';
import { useFrame } from '@react-three/fiber'
import './Shaders/PortalMaterial'

export default function Portal({ ...props }) {
  const group = useRef()
  const portalMaterial = useRef()
  const { nodes, materials } = useGLTF('/portal_v2.glb');

  const texture = useLoader(THREE.TextureLoader, '/portal/baked_port.jpg');
  texture.flipY = false;

  useFrame((state, delta) => {
    (portalMaterial.current.time += delta)
    console.log(portalMaterial.current)}
)
  return (
    <group ref={group} {...props} dispose={null}>
      <mesh
        geometry={nodes.PortalLight.geometry}
        material={nodes.PortalLight.material}
        position={[0, 0.81, 1.99]}
        rotation={[1.57, 0, Math.PI]}
      >
        <portalMaterial 
          ref={portalMaterial} 
          blending={THREE.AdditiveBlending} 
          colorStart="#006466" 
          colorEnd="#4D194D" 
        />
      </mesh>
      <mesh
        geometry={nodes.poleLightR.geometry}
        material={nodes.poleLightR.material}
        position={[0.7, 0.56, 0.35]}
        scale={1.05}
        >
        <meshBasicMaterial color='#d9c6b0'/>
      </mesh>
      <mesh
        geometry={nodes.poleLightL.geometry}
        material={nodes.poleLightL.material}
        position={[-0.235, 0.005, -0.45]}
      >
        <meshBasicMaterial color='#d9c6b0'/>
      </mesh>
      <mesh
        geometry={nodes.mergeBaked.geometry}
        material={nodes.mergeBaked.material}
        position={[-0.01, 0, 0]}
        // rotation={[-Math.PI, 0, -Math.PI]}
        rotation={[0, 0, 0]}
      >
        <meshBasicMaterial map={texture}/>
      </mesh>
    </group>
  )
}

useGLTF.preload('/portal_v2.glb')
